<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12">
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    disabled
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" >
                <v-text-field
                    label="Name"
                    :rules="[isRequired]"
                    v-model="form.name"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    label="Supplier Group"
                    v-model="form.group_id"
                    :items="supplierGroups"
                    item-value="id"
                    item-text="name"
                    @update:search-input="searchSupplierGroup"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-text-field
                    label="Phones"
                    v-model="form.phone"
                    :rules="[isRequired, isNumeric]"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    label="Email"
                    :rules="[isEmail]"
                    v-model="form.email"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-textarea
                    label="Address"
                    v-model="form.address"
                    outlined
                    dense
                    hide-details="auto">
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRequired, isEmail, isNumeric } from './../../utils/validations';

export default {
    name: "SupplierForm",
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                id: null,
                code: null,
                name: null,
                phone: null,
                email: null,
                address: null,
                group_id: null
            }
        }
    },
    computed: {
        ...mapGetters({
            supplierGroups: "purchase/supplierGroup/search/data"
        }),
        editMode() {
            return this.form.id ? true : false;
        }
    },
    methods: {
        ...mapActions({
            create: "purchase/supplier/create",
            update: "purchase/supplier/update",
            searchSupplierGroup: "purchase/supplierGroup/search/get"
        }),
        isRequired,
        isEmail,
        isNumeric,
        submit(idempotentKey) {
            // 1. Validate the form.
            if(!this.$refs.form.validate()) return;
            // 2. Set the proper action.
            let action = this.editMode ? this.update : this.create;
            // 3. Sumit
            this.$emit("loading", true);
            action({...this.form, idempotentKey}).then(response => {
                this.form = response.data;
                this.$emit("submit", response.data);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.$emit("error", message);
            }).finally(() => {
                this.$emit("loading", false);
            });
        }
    },
    mounted() {
        this.form = { ...this.form, ...this.value}
    }
}
</script>

<style>

</style>